import styled from '@emotion/styled'
import { AnimatedTitle } from 'app/components/Common/Animation/AnimatedTitle'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { styles } from 'app/theme'
import React, { memo } from 'react'

export interface Props {
  description?: string
  title?: string
}

export const Policy = memo(function Policy({ description, title }: Props) {
  if (!description || !title) {
    return null
  }

  return (
    <Container>
      {title ? <Title tag="h1" text={title} /> : null}

      {description ? (
        <FadeInUp delay={0.2} threshold={0}>
          <Description dangerouslySetInnerHTML={{ __html: description }} />
        </FadeInUp>
      ) : null}
    </Container>
  )
})

const Container = styled.section`
  margin-bottom: 7.5rem;
  padding: 10.625rem 10.833vw 0;
  position: relative;

  @media (max-width: 1199px) {
    margin-bottom: 3.75rem;
    padding: 7rem 2rem 0;
  }
`

const Title = styled(AnimatedTitle)`
  ${styles.title.xm}

  @media (max-width: 1199px) {
    ${styles.title.medium}
  }
`

const Description = styled.div`
  ${styles.description}

  margin-top: 1.5rem;
  text-align: left;
  word-wrap: break-word;

  p {
    margin-block-start: 1.5em;
  }

  ul {
    margin: 0.25rem 0 0 0;
    padding: 0 0.125rem;
    li {
      margin-top: 0.1875rem;
      padding-left: 0.875rem;
      position: relative;
      &:before {
        content: '';
        width: 0.3125rem;
        height: 0.3125rem;
        background: ${({ theme }) => theme.colors.variants.primaryDark};
        border-radius: 50%;
        opacity: 0.4;
        position: absolute;
        top: 0.5625rem;
        left: 0;
      }
    }
  }

  a {
    text-decoration: underline;
  }
`
